// extracted by mini-css-extract-plugin
export default {"multiplierAdditionalInfo":"ZOGx4O7vWhRYr4IaXqOQ"};